import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Label } from '@hydra/common/components';
import { Grid } from '@material-ui/core';
import get from 'lodash/get';

import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import DCUrlLabel from '@hydra/routes/crawler/components/DCUrlLabel';

export class DeepPagesRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;
    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const sourceUrl = new DCUrl(domain, issue.source_url);
    const errorUrl = new DCUrl(domain, issue.error_url);

    return (
      <Grid container className={classNameProp} alignItems='flex-start'>
        <Grid item {...columnStyles[0]}>
          <Label style={parseSeverity(issue.severity)} noBackground>
            <strong>
              {issue.depth}
            </strong>
          </Label>
        </Grid>

        <Grid item {...columnStyles[1]}>
          <DCUrlLabel className='truncate' url={sourceUrl} severity={issue.severity} />
        </Grid>

        <Grid item {...columnStyles[2]}>
          <DCUrlLabel className='truncate' url={errorUrl} severity={issue.severity} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(DeepPagesRow, {
  issue: graphql`
    fragment DeepPagesRow_issue on DeepPage {
      id
      type
      severity
      depth
      error_url
      source_url
    }
  `
});
